import { FC } from "react";
import { PlainButton, Menu } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { ReactComponent as MenuIcon } from "./assets/menu.svg";

export const NoSubscriptionHeaderMenu: FC = () => {
  const { t } = useTranslations();
  return (
    <Menu
      placement="right-end"
      renderTrigger={({ Trigger, triggerRef }) => (
        <Trigger
          as={PlainButton}
          ref={triggerRef}
          className="h-10 w-10 rounded-full transition-all duration-300 hover:bg-grey-100"
        >
          <MenuIcon className="text-white" />
        </Trigger>
      )}
      onSelect={(_item, _event, close) => close()}
      sections={[
        [
          {
            id: "switch-workspace",
            label: t({
              id: "workspace-settings-page.switch-workspace",
              defaultMessage: "Switch Workspace",
            }),
            onSelect: () =>
              document
                .querySelector<HTMLButtonElement>(
                  "[data-id=select-entity-popover-trigger]"
                )
                ?.click(),
          },
        ],
      ]}
    />
  );
};
